import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { MusicProvider } from "./context/MusicContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Founder from "./components/Founder";
import About from "./components/About";
import Services from "./components/Services";
import Transfers from "./components/Transfers";
import Experiences from "./components/Experiences";
import Properties from "./components/Properties";
import BelAir from "./components/BelAir";
import SummerGift from "./components/SummerGift";
import WhyUs from "./components/WhyUs";
import Pricing from "./components/Pricing";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import WhatsApp from "./components/WhatsApp";

const Home = () => {
  return (
    <MusicProvider>
      <div className="grain bg-[#FAF8F3] text-[#18324F] overflow-x-clip">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Founder />
          <About />
          <Services />
          <Transfers />
          <Experiences />
          <Properties />
          <BelAir />
          <SummerGift />
          <WhyUs />
          <Pricing />
          <Testimonials />
          <Faq />
          <Contact />
        </main>
        <WhatsApp />
      </div>
    </MusicProvider>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
